import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  AppDataService,
  GlobalVariablesService,
  StepRequest,
  StepsService,
  StepResponse
} from '@tmhcc-ng-lib/data-service';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { GlobalService } from '@tmhcc-ng-lib/global-services';
import {
  ProductsNavRoutes,
  SubmissionType,
  UpdatePolicy,
  AllowedRoutes,
  Status,
  InsuredFormType
} from '@tmhcc-ng-lib/models';
import { IsTrue } from 'libs/util/binary-util';
import { AccordionService } from '../../accordion-menu/accordion.service';

@Injectable({
  providedIn: 'root'
})
export class StepNevigationService {
  constructor(
    private loaderService: LoaderService,
    private globalVarService: GlobalVariablesService,
    private plocyService: StepsService,
    private accordionService: AccordionService,
    private appDataService: AppDataService,
    private globalService: GlobalService,
    private router: Router
  ) {}

  stepNevigation(policyInfo: StepResponse, showSummaryTab = false) {
    this.loaderService.show();
    this.globalVarService.resetGlobalVariableCache(!showSummaryTab);
    this.appDataService.showSummary.next(showSummaryTab);

    this.globalVarService.policyId = policyInfo.PolicyId;
    this.globalVarService.policyVersionId = policyInfo.PolicyTxnNum;
    this.globalVarService.policyTxnId = policyInfo.PolicyTxnId;
    this.globalVarService.policyTxnNum = policyInfo.PolicyTxnNum;
    this.globalVarService.policyNum = `${policyInfo.PolicyId}-${policyInfo.PolicyTxnNum}`;
    this.globalVarService.performPolicyTypeValidation = policyInfo.IsPolicyNew;
    this.globalVarService.policyTypeId = policyInfo.PolicyTypeId;

    this.globalVarService.productName = this.globalService.getProductName(
      'userDetails',
      policyInfo.PolicyTypeId
    );

    this.globalVarService.showSubmitButton = !policyInfo.UnderwritingDocumentsRequired;

    this.accordionService.hideDocumentSubmenu(
      IsTrue(this.globalVarService.showSubmitButton)
    );

    if(policyInfo.PendingEndorsementENReason == 'Additional Insured - Blanket' ){        
      this.globalVarService.additionalInsuredFormType=InsuredFormType.Blanket; 
      this.globalVarService.insuredContactId = 0;                      
    }    
    else{      
        this.globalVarService.additionalInsuredFormType=InsuredFormType.Scheduled;                               
    }      

    if (this.globalVarService.productName !== 'undefined') {
      let prodRoutes = '/bound';
      //ProductsNavRoutes[this.globalVarService.productName]['Insured'];
      let submissionType = SubmissionType[this.globalVarService.productName];
      if (
        (policyInfo.SummaryDetails.SummaryPendingItem.SubmissionType ===
          Status.Renewal &&
          policyInfo.SummaryDetails.SummaryPendingItem.PolicyStatus ===
            Status.RenewalReview) ||
        (policyInfo.SummaryDetails.SummaryPendingItem.SubmissionType ===
          Status.EnSubmissionType &&
          policyInfo.SummaryDetails.SummaryPendingItem.PolicyStatus ===
            Status.EnPolicyStatus)
      ) {
        let nevigationUrl =
          submissionType[
            policyInfo.SummaryDetails.SummaryPendingItem.SubmissionType
          ] || prodRoutes;
        this.router.navigate([nevigationUrl]);
      } else {
        let nevigationUrl =
          submissionType[
            policyInfo.SummaryDetails.SummaryPendingItem.PolicyStatus
          ] || prodRoutes;
        this.router.navigate([nevigationUrl]);
        this.globalVarService.policyStatus =
          policyInfo.SummaryDetails.SummaryPendingItem.PolicyStatus;
      }
    } else {
      this.loaderService.hide();
    }
  }
}
